import React from 'react';
import { freeBallTarget, minimumFoulPoints } from '../utils/snookerScoring';
import './SnookerScoringNotice.css';

export default function SnookerScoringNotice({ gameState, addFoulPoints, potFreeBall, cancelScoringMode }) {
    if (gameState.isGameFinished || gameState.frameOver) return null;
    const player = gameState.currentPlayer === 1 ? gameState.firstPlayer : gameState.secondPlayer;
    const opponent = gameState.currentPlayer === 1 ? gameState.secondPlayer : gameState.firstPlayer;
    const target = freeBallTarget(gameState);
    if (!gameState.selectingFoulValue && (!gameState.freeBallActive || !target)) return null;
    return (
        <section className="snooker-scoring-notice" aria-label="Snooker scoring action">
            <div role="status">
                {gameState.selectingFoulValue
                    ? <>Foul by {player} · Points to {opponent}. Choose the penalty:</>
                    : <>Free ball for {player} · Counts as {target.name} ({target.points}).</>}
            </div>
            <div className="snooker-scoring-options">
                {gameState.selectingFoulValue
                    ? [4, 5, 6, 7].map(points => (
                        <button key={points} disabled={points < minimumFoulPoints(gameState)}
                            onClick={() => addFoulPoints(points)}>{points} points</button>
                    ))
                    : <>
                        <button onClick={() => potFreeBall(false)}>Pot free ball (+{target.points})</button>
                        <button onClick={() => potFreeBall(true)}>
                            Free ball + {target.name} (+{target.name === 'Red' ? 2 : target.points})
                        </button>
                    </>}
                <button onClick={cancelScoringMode}>Cancel</button>
            </div>
        </section>
    );
}
